import {
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
} from '@mui/material';
import { useRazorpayPlans } from 'api/apiHooks';
import PartialPageSpinner from 'components/PartialPageSpinner';
import usePortalId from 'hooks/portal/usePortalId';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  enableSubscription,
  setRazorpayDetails,
} from 'redux/slices/formEditor';
import { dispatch, useSelector } from 'redux/store';
import axiosInstance from 'utils/axios';

export default function RazorpayFormSettings() {
  const portalId = usePortalId();
  const { t } = useTranslation();
  const { data: razorpayPlans, isLoading } = useRazorpayPlans(portalId);
  const {
    formDetails,
    subscription: isSubscriptionEnabled,
    razorpay_plan_id,
  } = useSelector(state => state.formEditor);

  useEffect(() => {
    if (formDetails && formDetails.formId) {
      axiosInstance.post(
        '/formpayhome/portal/updatePortalFormSettings/' + formDetails.formId,
        {
          form_id: formDetails.formId,
          subscription: isSubscriptionEnabled,
          razorpay_plan_id: razorpay_plan_id,
        }
      );
    }
  }, [isSubscriptionEnabled, formDetails?.formId, razorpay_plan_id]);

  return (
    <div>
      <FormControlLabel
        className='mb-5'
        control={
          <Switch
            name='mode'
            checked={isSubscriptionEnabled}
            onChange={e => dispatch(enableSubscription(e.target.checked))}
          />
        }
        label={t('enable_subscription')}
      />

      {isSubscriptionEnabled ? (
        isLoading ? (
          <PartialPageSpinner />
        ) : (
          <FormControl fullWidth>
            <InputLabel id='razorpay_plan_id'>
              {t('select_razorpay_plan')}
            </InputLabel>
            <Select
              id='razorpay_plan_id'
              value={razorpay_plan_id}
              label={t('select_razorpay_plan')}
              variant='outlined'
              name='razorpay_plan_id'
              onChange={e =>
                dispatch(
                  setRazorpayDetails({
                    razorpay_plan_id: e.target.value,
                    razorpay_plan_amount: razorpayPlans?.data.items.find(
                      plan => plan.id === e.target.value
                    )?.item.amount,
                  })
                )
              }
            >
              {razorpayPlans?.data.items.map((plan, index) => {
                return (
                  <MenuItem key={plan.id} value={plan.id}>
                    {plan.item.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        )
      ) : null}
    </div>
  );
}
